export default {
  state: {
    message: {
      show: false,
      // error & success (TODO: warrning)
      timeout: 2000,
      context: ''

    }
  },
  mutations: {
    getMessage(state, {
      context
    }) {
      state.message.show = true
      state.message.context = context

    },
    hideMessage(state) {
      state.message.show = false
    },
    timeMessage(state, time) {
      state.message.timeout = time
    }
  },
  actions: {
    getMessage({
      commit
    }, {
      context,
      timeout
    }) {
      commit('getMessage', {
        context,
        timeout
      })
      const State = this;
      if(DEBUG) console.log("THIS STATE =", State.state.message);
      // Mutations cant be async
      commit('timeMessage', timeout)
      setTimeout(() => {

        commit('hideMessage')
      }, timeout)
    },
    timeMessage({
      commit
    }, setTime) {
      commit('timeMessage', setTime)
    }
  },
  getters: {
    message(state) {
      return state.message
    }
  }
}
